import BigNumber from "bignumber.js";
export const serializeTronTransaction = ({ amount, recipient, family, mode, resource, duration, }) => ({
    amount: amount.toString(),
    recipient,
    family,
    mode,
    resource,
    duration,
});
export const deserializeTronTransaction = ({ amount, recipient, family, mode, resource, duration, }) => ({
    amount: new BigNumber(amount),
    recipient,
    family,
    mode,
    resource,
    duration,
});
//# sourceMappingURL=serializer.js.map